module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg6.04eff1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg6.jpg
// module id = Mz3p
// module chunks = 7